import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { MenuAudience } from '@interface/audience.interface';
import { AudienceService } from '@service/api/audience.service';
import { HydraCollection } from '@interface/hydra/collection.interface';
import { Observable, of } from 'rxjs';


export interface Audience {
  image: string;
  imageAlt: string;
  title: string;
  slug: string;
  description: string;
}

@Component({
  selector: 'app-audience-list',
  templateUrl: './audience-list.component.html',
  styleUrls: ['./audience-list.component.scss']
})

export class AudienceListComponent {

  public constructor(
    private titleService: Title,
    private meta: Meta,
    private api: AudienceService
  ) {
    this.titleService.setTitle('M|Catering - Michigan Catering Menu')
    this.meta.updateTag({
      name: 'description',
      content: 'View the Michigan Catering menu and choose from a diverse selection of fresh, authentic foods for on- or off-campus events like weddings, special events, and more.'
    });
    this.meta.updateTag({
      name: 'og:title',
      content: 'Michigan Catering Menu'
    });
    this.meta.updateTag({
      name: 'og:description',
      content: 'View the Michigan Catering menu and choose from a diverse selection of fresh, authentic foods for on- or off-campus events like weddings, special events, and more.'
    });
  }

  audienceList$:Observable<HydraCollection> = this.api.getAll();

  diningToGo = {
    image: '/assets/images/menu/catering-to-go.jpg',
    imageAlt: 'Close up of compostible to-go container filled with chicken salad.',
    title: 'Catering to Go',
    slug: 'catering-to-go',
    description: 'For on-campus meetings and gatherings. We offer pickup or delivery services Monday-Friday.'
  }

}
